// utils
import axios from '../../../utils/axios';

const setRates = async (data) => {
  try {
    const response = await axios({
      method: 'post',
      url: `/lexus/wallet/api/wallet/rates/store`,
      data,
    });
    const res = await response.data;
    return res;
  } catch (error) {
    throw new Error(JSON.stringify(error));
  }
};

export { setRates };
